import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import NumberInputComma from '../../component/dccore-form/numberInputComma.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'

if ($('#product_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#product_form',
    components: {
      RingLoader,
      TextInput,
      NumberInput,
      Singleselect,
      Multiselect,
      Checkbox,
      NumberInputComma
    },
    mixins: [mixins],
    data: {
      loading: 0,
      disableWeight: false,
      form: {
        entity: {
          priority : 5,
          active: true
        },
        options: {
          categories: [],
          units: [],
          materials: [],
          errors: {},
        }
      },
      entityId: null,
    },
    watch: {
      'form.entity.unit' : function() {
        if (this.form.entity.unit === 'kg') {
          this.form.entity.weight = 1
          this.disableWeight = true
        } else {
          this.disableWeight = false
        }
      },
      'form.entity.priority': function (val) {
        this.form.entity.active = val < 10
      }
    },
    mounted: function () {
      this.loading++

      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getProduct()
      }

      this.getCategories()
      this.getUnits()
      this.getMaterials()

      this.loading--
    },
    methods: {
      createProduct(redirect) {
        let url = Routing.generate('api_post_product')

        let data = { data: this.form.entity }
        this.loading++

        this.$http.post(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('product_grid'))
          } else {
            toastr.success(Translator.trans('product.create.created'))
            this.form.options.errors = {}
          }
          this.loading--

        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      updateProduct(redirect) {
        this.loading++

        let url = Routing.generate('api_patch_product', {
          id: this.entityId,
        })

        let data = { data: this.form.entity }

        this.$http.patch(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('product_grid'))
          } else {
            toastr.success(Translator.trans('product.update.updated'))
            this.form.options.errors = {}
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      getProduct() {
        this.loading++
        let url = Routing.generate('api_get_product', { id: this.entityId,
          context: 'edit' })

        this.$http.get(url).then(response => {
          this.form.entity = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getUnits() {
        let url = Routing.generate('api_get_products_units')
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.units = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getCategories() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'product_category',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.categories = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getMaterials() {
        this.loading++
        let url = Routing.generate('api_get_materials_available_for_product', { context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.materials = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      }
    }
  })
}
